/**
 * 用户数据接口
 */
import request from '@/utils/requestUtil';

const API = {
	USER_PROVIDER_INFO_URL: '/pub/pubEnterpriseInfo/currentInfo',
	REVIEW_SAVE_URL: '/tool/review/save',
	REVIEW_HISTORY_LIST_URL: '/tool/review/listHistoryResult',
	REVIEW_RESULT_URL: '/tool/review/getResult?id=',
	REVIEW_COUNT_URL: '/tool/review/reviewCount?reviewType=',
	REVIEW_RECYCLE_URL: '/tool/review/toRecycleBin?id=',
	REVIEW_REMOVE_URL: '/tool/review/removeBaseAndDetail?id=',
	REVIEW_RECOVERY_URL: '/tool/review/recovery?id=',
	SCALE_CALC_URL: '/tool/scale/calc'
}

// 用户企业信息
export const reqUserEnterprise = () => request.get(API.USER_PROVIDER_INFO_URL, { needToken: true });
// 提交数据
export const reqReviewSave = (data) => request.post(API.REVIEW_SAVE_URL, data, { defaultToken: true });
// 测评历史记录
export const reqReviewHistoryList = (url) => request.get(API.REVIEW_HISTORY_LIST_URL + url, { needToken: true });
// 测评结果
export const reqReviewResult = (id) => request.get(API.REVIEW_RESULT_URL + id, { needToken: true });
// 测评总数量
export const reqReviewCount = (type) => request.get(API.REVIEW_COUNT_URL + type);
// 放入回收站
export const reqReviewRecycle = (id) => request.post(API.REVIEW_RECYCLE_URL + id, {}, { needToken: true });
// 彻底删除
export const reqReviewRemove = (id) => request.post(API.REVIEW_REMOVE_URL + id, {}, { needToken: true });
// 恢复
export const reqReviewRecovery = (id) => request.post(API.REVIEW_RECOVERY_URL + id, {}, { needToken: true });
// 企业规模测算
export const reqScaleCalc = (url) => request.get(API.SCALE_CALC_URL + url);